export default __webpack_public_path__ + "static/media/strawberry.96b7edd1.png";